import CartItems from "../Components/CartsItems/CartsItems";

const Cart = () => {
  return (
    <div>
      <CartItems />
    </div>
  );
};

export default Cart;
